module.exports = __webpack_public_path__ + "img/packaging.012645f.webp";